export const FIND_PROCESS_STATEMENT_REQUEST = 'FIND_PROCESS_STATEMENT_REQUEST';

export const findProcessStatementRequest = ( id ) => ({
    type: FIND_PROCESS_STATEMENT_REQUEST,
    payload: { id }
});
